import { eventsRequest } from '../../utils/eventsRequest.tsx';

type PayloadType = {
  pricingId: number,
  childId: number,
  userId: number
}

const addToWaitlist = async (payload: PayloadType) => {
  const arrayResponse = {
    success: false,
    message: 'Failed to add you on the waitlist.',
  };

  try {
    const response = await eventsRequest('/waitlist', 'post', payload);

    if (response.status === 200 || response.status === 201) {
      arrayResponse.success = true;
      arrayResponse.message = 'You were added to the waitlist successfully.';
    }

    return arrayResponse;
  } catch (error: any) {
    if (error.response && error.response.status === 400) {
      arrayResponse.message = error.response.data.message;
    }

    return arrayResponse;
  }
};

export default addToWaitlist;
